


























































































































































































































































































import BaseComponent from '@/components/base-component.vue';
import UiAutoCompleteAddress from '@/components/UI/autocomplete-address.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import UiAutocomplePatients from '@/components/UI/autocomplete-patients.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { PropostaAprovacaoParmDTO, PropostaFreteSolicParmDTO } from '@/interfaces/shipping-quote';
import * as service from '@/services/shipping-quote';
import { getUFs } from '@/services/utils';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import ShippingQuoteStatusChip from '../shipping-quote-status-chip.vue';
import ShippingQuoteRequestPatientDetailsModal from './shipping-quote-request-patient-details-modal.vue';

@Component({
  components: {
    PermissionAuth,
    UiAutocompleClientsSubsidiaries,
    UiAutocomplePatients,
    UiAutoCompleteAddress,
    ShippingQuoteStatusChip,
    ShippingQuoteRequestPatientDetailsModal
  }
})
export default class ShippingQuoteRequestForm extends BaseComponent {
  @Prop()
  public chave: string;

  loadingUnidade = false;
  unidades = [];
  unidade = null;
  paciente = null;
  pacienteDetalhes = null;
  mudancaEnderecoDto = null;
  tpBolsaCompart = null;
  endereco = null;
  horario = null;
  ufs = [];

  showPacienteDetalhesModal = false;

  formOpen = false;
  dto: any = {};
  selected = null;
  description = null;
  novo = true;

  public form: any = {
    valid: false,
    rules: {
      client: [(v) => !!v || 'Selecione a unidade/cliente'],
      patient: [(v) => !!v || 'Selecione ou cadastre um paciente'],
      tpMudancaEndereco: [(v) => v != null || 'Informe o tipo de mudança de endereço'],
      mudancaEndData: [(v) => (v != null && v != '') || 'Informe a data de início'],
      mudancaEndDatas: [(v) => (v != null && v != '') || 'Informe o período'],
      tpBolsaCompart: [(v) => v != null || 'Informe o tipo de bolsa'],
      address: [(v) => !!v || 'Informe o endereço de entrega'],
      hour: [(v) => (!!v && v.length == 5) || 'Informe o horário de entrega desejado'],
      description: [(v) => (!!v && v.length > 0) || 'Informe o motivo'],
      logradouro: [(v) => !!v || 'Informe o logradouro'],
      numero: [(v) => !!v || 'Informe o número'],
      bairro: [(v) => !!v || 'Informe o bairro'],
      cidade: [(v) => !!v || 'Informe a cidade'],
      estado: [(v) => !!v || 'Informe o estado'],
      cep: [(v) => !!v || 'Informe o CEP']
    }
  };

  private headers: any = [
    { text: '', sortable: false, width: '10' },
    { text: 'Horário limite de prescrição', sortable: false, width: '15%' },
    { text: 'Horário limite de entrega', sortable: false, width: '15%' },
    { text: 'Custo do frete', sortable: false, width: '15%' },
    { text: 'Observação', sortable: false }
  ];

  public $refs!: {
    form: HTMLFormElement;
  };

  mounted() {
    this.loadingUnidade = true;
    service.listClientsUnitsShippingQuoteRequest().subscribe(
      (res) => {
        this.unidades = res;
        this.loadingUnidade = false;
      },
      (error) => {
        this.showToastApiError(error);
        this.loadingUnidade = false;
      }
    );
    getUFs().subscribe((res) => {
      this.ufs = res;
    });
  }

  @Watch('chave', { immediate: true })
  onChaveChange(chave) {
    if (!chave) {
      this.formOpen = true;
      this.novo = true;
      return;
    }

    this.novo = false;

    this.load();
  }

  load() {
    this.loader.start('Carregando...');
    service.getShippingQuoteRequest(this.chave).subscribe(
      (res) => {
        this.dto = res;
        if (this.dto.propostaAceita) {
          this.selected = this.dto.propostaAceita.id;
        }
        this.formOpen = true;
      },
      (error) => {
        this.showToastApiError(error);
        this.closeForm();
      },
      () => {
        this.loader.stop();
      }
    );
  }

  closeForm() {
    this.$emit('close');
    this.formOpen = false;
  }

  save() {
    if (!this.$refs.form.validate()) {
      return;
    }
    this.loader.start('Processando...');

    let observable = null;
    if (!this.dto.chave) {
      let payload = new PropostaFreteSolicParmDTO();
      payload.idUnidade = this.unidade.id;
      payload.idPaciente = this.paciente.id;
      if (this.pacienteDetalhes.showTpMudancaEndereco && this.mudancaEnderecoDto) {
        payload.mudancaDefinitiva = this.mudancaEnderecoDto.mudancaEndDefinitiva;
        payload.dataInicioMudanca = this.mudancaEnderecoDto.mudancaEndDefinitiva
          ? this.mudancaEnderecoDto.mudancaEndData
          : this.mudancaEnderecoDto.mudancaEndDatas[0];
        payload.dataFimMudanca = this.mudancaEnderecoDto.mudancaEndDefinitiva
          ? null
          : this.mudancaEnderecoDto.mudancaEndDatas[1];
      }
      payload.tpBolsaCompart = this.tpBolsaCompart;
      payload.endereco = this.endereco;
      payload.horarioEntrega = this.horario;
      observable = service.saveShippingQuoteRequest(payload);
    } else {
      let payload = new PropostaAprovacaoParmDTO();
      payload.chave = this.dto.chave;
      if (this.selected == -1) {
        payload.motivo = this.description;
        payload.propostaAceita = false;
      } else {
        payload.idPropostaAceita = this.selected;
        payload.propostaAceita = true;
      }
      observable = service.saveShippingQuoteClientApprove(payload);
    }

    observable.subscribe(
      (res) => {
        this.loader.stop();
        this.toast.show(res, 'success');
        this.$emit('save');
        this.formOpen = false;
      },
      (error) => {
        this.loader.stop();
        this.showToastApiError(error);
      }
    );
  }

  @Watch('selected')
  onSelectedChange(val) {
    if (val == -1) {
      setTimeout(() => {
        this.$refs['taDescription'].focus();
      }, 300);
    }
  }

  isShowHorario() {
    return this.tpBolsaCompart === false;
  }

  @Watch('unidade')
  onUnidadeChange(uni) {
    this.tpBolsaCompart = null;
    if (!uni) {
      return;
    }
    if (uni.usoBolsaMulticompart.exigirUso) {
      this.tpBolsaCompart = true;
    }

    if (!uni.usoBolsaMulticompart.permiteUso) {
      this.tpBolsaCompart = false;
    }
  }

  @Watch('paciente')
  onPacienteChange(pac) {
    this.pacienteDetalhes = null;
    this.mudancaEnderecoDto = null;

    if (this.paciente == null || this.paciente.id == null) {
      return;
    }

    this.loader.start('Processando...');
    service.getShippingQuotePatientDetails(this.paciente.id, this.unidade.id).subscribe(
      (res) => {
        this.pacienteDetalhes = res;
        this.loader.stop();
        this.checkShowTpMudancaEnderecoModal();
      },
      (error) => {
        this.showToastApiError(error);
        this.loader.stop();
      }
    );

    if (this.isPodeEscolherTipoBolsa()) {
      this.tpBolsaCompart = null;
    } else {
      this.checkShowTpMudancaEnderecoModal();
    }
  }

  @Watch('tpBolsaCompart')
  onTpBolsaCompartChange(tp) {
    this.checkShowTpMudancaEnderecoModal();
  }

  checkShowTpMudancaEnderecoModal() {
    setTimeout(() => {
      if (!this.unidade || !this.paciente || !this.pacienteDetalhes) {
        return;
      }

      if (!this.pacienteDetalhes.showTpMudancaEndereco) {
        return;
      }

      this.showPacienteDetalhesModal = !this.isPodeEscolherTipoBolsa() || this.tpBolsaCompart != null;
    }, 100);
  }

  editTpMudancaEndereco() {
    this.showPacienteDetalhesModal = true;
  }

  onPacienteTpMudancaSave(dto) {
    this.showPacienteDetalhesModal = false;
    this.mudancaEnderecoDto = dto;
    if (dto.mudancaEndDefinitiva) {
      this.mudancaEnderecoDto.desc = 'Definitivo, a partir de ' + this.dateFormatHelper(dto.mudancaEndData, 'BR');
    } else {
      this.mudancaEnderecoDto.desc =
        'Temporário, no período de ' +
        this.dateFormatHelper(dto.mudancaEndDatas[0], 'BR') +
        ' a ' +
        this.dateFormatHelper(dto.mudancaEndDatas[1], 'BR');
    }
  }

  onPacienteTpMudancaClose() {
    this.showPacienteDetalhesModal = false;
    this.tpBolsaCompart = null;
  }

  isPodeEscolherTipoBolsa() {
    return (
      this.unidade != null &&
      this.unidade.usoBolsaMulticompart.permiteUso &&
      !this.unidade.usoBolsaMulticompart.exigirUso
    );
  }
}
